var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dt',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._t("question")],2),_vm._v(" "),_c('dd',{staticClass:"mt-2 text-base text-gray-500"},[_vm._t("answer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }